<template>
<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">

		<div class="row">
			<div class="columns">
				<h4>{{item.product.name}}</h4>
			</div>
			<div class="columns shrink" v-if="status">
				<div class="c-label c-label--secondary" @click="trigger('change-status')">{{item.status.name}}
					<svg class="margin-l-4" xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 512 512"><path fill="currentColor" d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>
				</div>
			</div>
		</div>

		<div class="fs-small color-gray-500 margin-b-16" v-if="product_group">{{product_group}}</div>

		<c-splitbutton class="margin-b-24" :buttons="buttons" :buttonText="'Ticket aanmelden'" v-if="buttons.length > 0"></c-splitbutton>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Eindklant</span>
			</div>
			<div class="columns small-12 medium-8">
				{{item.product.client.name}}
			</div>
		</div>
		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Artikelnummer</span>
			</div>
			<div class="columns small-12 medium-8">
				{{item.product.article_number}}
			</div>
		</div>
        <div class="row margin-b-16 fs-xsmall">
            <div class="columns small-12 medium-4">
                <span class="color-gray-600 font-heading">Projectnummer</span>
            </div>
            <div class="columns small-12 medium-8">
                {{ item.project ? item.project.number : '' }}
            </div>
        </div>
		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Serienummer</span>
			</div>
			<div class="columns small-12 medium-8">
				{{item.serial}}
			</div>
		</div>
        <div class="row margin-b-16 fs-xsmall">
            <div class="columns small-12 medium-4">
                <span class="color-gray-600 font-heading">Ordernummer</span>
            </div>
            <div class="columns small-12 medium-8">
                {{item.order_number}}
            </div>
        </div>
        <div class="row margin-b-16 fs-xsmall">
            <div class="columns small-12 medium-4">
                <span class="color-gray-600 font-heading">MAC Adres</span>
            </div>
            <div class="columns small-12 medium-8">
                {{item.mac_address}}
            </div>
        </div>
        <div class="row margin-b-16 fs-xsmall">
            <div class="columns small-12 medium-4">
                <span class="color-gray-600 font-heading">Asset ID</span>
            </div>
            <div class="columns small-12 medium-8">
                {{item.tag_number}}
            </div>
        </div>
        <div class="row margin-b-16 fs-xsmall">
            <div class="columns small-12 medium-4">
                <span class="color-gray-600 font-heading">Aanschafdatum</span>
            </div>
            <div class="columns small-12 medium-8">
                {{ $filter.datetime(item.date_in_use) }}
            </div>
        </div>
		<div class="row margin-b-16 fs-xsmall">
            <div class="columns small-12 medium-4">
                <span class="color-gray-600 font-heading">Verzenddatum</span>
            </div>
            <div class="columns small-12 medium-8">
                {{ $filter.datetime(item.shipping_date) }}
            </div>
        </div>
		<div class="row margin-b-16 fs-xsmall">
            <div class="columns small-12 medium-4">
                <span class="color-gray-600 font-heading">Startdatum contract</span>
            </div>
            <div class="columns small-12 medium-8">
                {{ $filter.datetime(item.start_date_contract) }}
            </div>
        </div>
		<div class="row margin-b-16 fs-xsmall">
            <div class="columns small-12 medium-4">
                <span class="color-gray-600 font-heading">Einddatum contract</span>
            </div>
            <div class="columns small-12 medium-8">
                {{ $filter.datetime(item.end_date_contract) }}
            </div>
        </div>
		<div class="row margin-b-16 fs-xsmall">
            <div class="columns small-12 medium-4">
                <span class="color-gray-600 font-heading">DaaS</span>
            </div>
            <div class="columns small-12 medium-8">
                {{ item.daas ? 'Ja' : 'Nee' }}
            </div>
        </div>
		<div class="row margin-b-16 fs-xsmall" v-if="item.daas">
            <div class="columns small-12 medium-4">
                <span class="color-gray-600 font-heading">Voorraadeigenaar</span>
            </div>
            <div class="columns small-12 medium-8">
                {{ item.stock_owner }}
            </div>
        </div>
		<div class="row margin-b-16 fs-xsmall">
            <div class="columns small-12 medium-4">
                <span class="color-gray-600 font-heading">Locatie</span>
            </div>
            <div class="columns small-12 medium-8">
				{{item.address !== null ? $filter.address(item.address) : '' }}
            </div>
        </div>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Omschrijving</span>
			</div>
			<div class="columns small-12 medium-8">
				{{item.product.description}}
			</div>
		</div>
		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">EOL</span>
			</div>
			<div class="columns small-12 medium-8">
				{{item.eol_time}}
			</div>
		</div>
		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Bundel</span>
			</div>
			<div class="columns small-12 medium-8">
				<div v-for="bundle in item.product.bundles" :key="bundle.id">
					{{bundle.name}} <br>
				</div>
			</div>
		</div>
		<div class="row margin-b-16 fs-xsmall" v-if="item.client">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">In gebruik door</span>
			</div>
			<div class="columns small-12 medium-8" v-if="item.client.client_type_id == 3">
				<div>
					{{item.client.name}}<br>
				</div>
			</div>
			<div class="columns small-12 medium-8" v-else>
				<div>
					{{ item.client.contact?.first_name ?? '' }} {{ item.client.contact?.last_name ?? '' }}<br>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CSplitbutton from '@components/Splitbutton';
import {mapGetters} from 'vuex';

export default {
	components: { CSplitbutton },
	data(){
		return{
			status: '',
			product_group: ''
		}
	},
	props: {
		item: {
			required: true
		}
	},
	methods: {
		trigger(event) {
				this.$store.dispatch('listener/emit', event);
		},
		load(){
			if(this.item.events.length > 0){
				this.status = this.item.events.at(-1).status.name;
			}
			const product_group_id = this.item.product.product_group_id;
			this.$xhr.get('/api/product-groups/' + product_group_id).then( ({result}) => {
				this.product_group = result.name;
			}).catch((e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Productgroep kan niet worden ingeladen'});
			});
		},
	},
	computed: {
		...mapGetters({
			can: 'user/can',
		}),
		buttons() {
			const buttons = [];

			this.can('Voorraad wijzigen') && buttons.push({
				label: 'Bewerken',
				action: () => {
					this.trigger('update-item')
				},
			});

			buttons.push({
				label: 'Reparatie',
				action: () => {
					this.trigger('repair')
				},
			});
			buttons.push({
				label: 'EOL Swap',
				action: () => {
					this.trigger('swap')
				},
			});
			buttons.push({
				label: 'Mutatie',
				action: () => {
					this.trigger('mutation')
				},
			});

			return buttons;
		}
	},
	mounted(){
		this.load();
	}
}
</script>
